import { Component, OnInit } from '@angular/core';
import { ReporteCumplimientoService } from '../services/reporte-cumplimiento.service';
import {
    REPORTE_CUMPLIMIENTO_COLUMNS,
    REPORTE_CUMPLIMIENTO_FILTERS,
    ANIO_ACTUAL,
} from './reporte-cumplimiento-productor.table-data';

/**
 * Pantalla de **reporte de cumplimiento de productor**. Aquí vive la lógica de negocio y datos:
 * obtener información del backend (cuando se integre), armar los arreglos `filters`, `columns` y
 * `data` que espera {@link TableComponent}, y manejar eventos (`filtroColumna`, cambio de página,
 * etc.). La tabla compartida {@link TableComponent} no construye esos datos; solo los muestra.
 */
@Component({
    selector: 'app-reporte-cumplimiento-productor',
    templateUrl: './reporte-cumplimiento-productor.component.html',
    styleUrls: ['./reporte-cumplimiento-productor.component.css'],
})
export class ReporteCumplimientoProductorComponent implements OnInit {
    /** Paginación → `[pageSize]` / `[page]` / `[total]` */
    tamano = 10;
    pagina = 1;
    total = 300;

    /** Layout de filtros superiores en `app-table`. */
    styleFilters = 'col-md-2';

    /** Entradas de `app-table` (ver plantilla). */
    filters: unknown[] = [];
    columns: unknown[] = [];
    data: Record<string, unknown>[] = [];

    payload: unknown = {
        filter: { anioReporte: String(ANIO_ACTUAL) },
        page: 1,
        pageSize: 10,
    };


    constructor(
        private readonly reporteCumplimientoService: ReporteCumplimientoService
    ) {}

    activeTab: string = 'Productor/Importador';
    ngOnInit(): void {
        this.cargarReporteCumplimientoProductor();
    }

    async cargarReporteCumplimientoProductor() {
        this.cargarConfiguracionTabla();
        this.reporteCumplimientoService
            .getReporteCumplimientoProductor(this.payload)
            .subscribe((response: any) => {
                this.data = response.data;
                this.total = response.total;
            });
    }

    /** Asigna datos estáticos; sustituir por servicio/API cuando esté disponible. */
    private cargarConfiguracionTabla(): void {
        this.filters = [...REPORTE_CUMPLIMIENTO_FILTERS];
        this.columns = [...REPORTE_CUMPLIMIENTO_COLUMNS];
    }

    onFiltersChange(payload: { filter: Record<string, string>; page: number; pageSize: number }): void {
        this.pagina = payload.page;
        this.tamano = payload.pageSize;
        this.reporteCumplimientoService
            .getReporteCumplimientoProductor(payload)
            .subscribe((response: any) => {
                this.data = response.data;
                this.total = response.total;
            });
    }

    async cambiarTab(tab: string) {
        this.activeTab = tab;

        if (tab === 'Productor/Importador') {
            await this.cargarReporteCumplimientoProductor();
        } else if (tab === 'Comercializador') {
            // Crear lógica para comercializador
        }
    }
}
